import { render, staticRenderFns } from "./OperationPrice.vue?vue&type=template&id=04988d3f&"
import script from "./OperationPrice.vue?vue&type=script&lang=js&"
export * from "./OperationPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports